'use client'

import {ProductSimpleViewModel, ProductViewModel, ProductWithVariantsViewModel} from '../model'
import {observer, useLocalObservable} from 'mobx-react'
import React from 'react'

import {CertificatesPageContent} from '@/src/core/domain/entities/catalog'
import {Product} from '@/src/core/domain/entities/product'

import {useBasket} from '@/src/entities/basket'
import {isSimpleProduct} from '@/src/entities/product/helpers'

import {CertificatesViewModel} from '@/src/presentation/view-models/product/certificates'

const ProductContext = React.createContext<Nullable<ProductViewModel>>(null)

export const ProductProvider = observer(
  ({
    children,
    product: productData,
  }: React.PropsWithChildren & {
    product: Product
  }) => {
    const basket = useBasket()

    const productListViewModel = useLocalObservable(() => {
      let productListViewModel: ProductViewModel

      if (isSimpleProduct(productData)) {
        productListViewModel = new ProductSimpleViewModel(productData)
      } else {
        productListViewModel = new ProductWithVariantsViewModel(productData)
      }

      productListViewModel.setBasket(basket)

      return productListViewModel
    })

    return <ProductContext.Provider value={productListViewModel}>{children}</ProductContext.Provider>
  },
)

interface CertificatesProviderProps extends React.PropsWithChildren {
  data: CertificatesPageContent
}

const CertificatesContext = React.createContext<Nullable<CertificatesViewModel>>(null)

export const CertificateProider = observer(({children, data}: React.PropsWithChildren & CertificatesProviderProps) => {
  // const basket = useBasket()

  const certificatesViewModel = useLocalObservable(() => new CertificatesViewModel(data))

  return <CertificatesContext.Provider value={certificatesViewModel}>{children}</CertificatesContext.Provider>
})

export const useProductViewModel = (): ProductViewModel => {
  const productViewModel = React.useContext(ProductContext)

  if (!productViewModel) throw Error('Вызов не обернут в ProductProvider')

  return productViewModel
}

export const useCertificatesViewModel = () => {
  const certificatesViewModel = React.useContext(CertificatesContext)

  if (!certificatesViewModel) throw Error('Вызов не обернут в CertificateProider')

  return certificatesViewModel
}
